<mat-sidenav-container hasBackdrop="false" class="sidenav-full whiteSidenav">
  <mat-sidenav #auditSideNav mode="over" position="end" [(opened)]="logPayloadSidenavOpen" [disableClose]="true">

    <app-sidenav-content-facebook-form-log-payload [log]="selectedLog" (close)="logPayloadSidenavOpen = false">
    </app-sidenav-content-facebook-form-log-payload>

  </mat-sidenav>
  <mat-sidenav-content>
    <div class="auditContainer">
      <ng-container *ngFor="let log of logs">
        <div [ngClass]="selectedLog == log ? 'highlightSelected' : ''">
          <app-sidenav-content-facebook-form-log-item [log]="log" (selected)="openLogDetail(log)"
            (unselected)="logPayloadSidenavOpen = false">
          </app-sidenav-content-facebook-form-log-item>
        </div>
      </ng-container>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
